import styled from 'styled-components'

const TextInput = styled.input<{readonly error: boolean}>`
    line-height: 40px;
    width: 100%;
    height: 100%;

    background: #FFFFFF;

    border: ${props => props.error ? '2px solid rgba(245, 99, 99, .7)' : '2px solid #989898'};
    border-radius: 4px;
    outline: 0;
    box-sizing: border-box;

    padding: 0 17px; // 0 40px 0 17px
    transition: border .2s;
    z-index: 1;
        
    &:focus {
        border: ${props => props.error ? '2px solid rgba(245, 99, 99, .7)' : '2px solid rgba(27, 176, 206, .7)'};
    }

    &:focus + * {
        background-color: ${props => props.error ? 'rgba(245, 99, 99, .3)' : 'rgba(27, 176, 206, .3)'};
        border: ${props => props.error ? '5px solid rgba(255, 255, 255, 0)' : '5px rgba(27, 176, 206, .3)'};
    }
`

export default TextInput